import { render } from "./BusinessPlan.vue?vue&type=template&id=3ee9f8ce&scoped=true"
import script from "./BusinessPlan.vue?vue&type=script&lang=js"
export * from "./BusinessPlan.vue?vue&type=script&lang=js"

import "./BusinessPlan.vue?vue&type=style&index=0&id=3ee9f8ce&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee9f8ce"]])

export default __exports__